@if (hasData) {
  <div class="relative flex justify-center">
    <canvas class="w-full" #pieChart></canvas>
  </div>
} @else {
  <div class="my-2 py-2 text-center">
    <div class="icon-info-wrapper">
      <mat-icon>info</mat-icon>
    </div>
    <span class="text-sm uppercase" i18n
      >No hay suficientes datos para graficar</span
    >
  </div>
}
